<h1 mat-dialog-title>{{ 'dialogs.privacy.title' | translate }}</h1>


<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">
      {{ 'common.cta.close' | translate }}
    </a>
  </div> <!-- /.col -->
</div> <!-- /.row -->